import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { AuthProvider } from './context/AuthContext';
import './i18n';
import { LanguageProvider } from './context/LanguageContext';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LanguageProvider>
  <AuthProvider>
    <App />
  </AuthProvider>
  </LanguageProvider>
);
